"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var buttons_1 = require("./buttons");
var Paginator_styles_1 = require("./Paginator.styles");
var usePageNumbers_1 = require("./usePageNumbers");
var Paginator = function (_a) {
    var _b = _a.currentPage, currentPage = _b === void 0 ? 1 : _b, totalPages = _a.totalPages, siblingCount = _a.siblingCount, className = _a.className, onChange = _a.onChange, onFirst = _a.onFirst, onPrevious = _a.onPrevious, onNext = _a.onNext, onLast = _a.onLast, _c = _a.testId, testId = _c === void 0 ? 'Paginator' : _c, rest = __rest(_a, ["currentPage", "totalPages", "siblingCount", "className", "onChange", "onFirst", "onPrevious", "onNext", "onLast", "testId"]);
    var handleOnFirst = function () {
        onFirst === null || onFirst === void 0 ? void 0 : onFirst();
        onChange === null || onChange === void 0 ? void 0 : onChange(1, Math.max(currentPage, 1));
    };
    var handleOnPrevious = function () {
        onPrevious === null || onPrevious === void 0 ? void 0 : onPrevious();
        onChange === null || onChange === void 0 ? void 0 : onChange(currentPage - 1, currentPage);
    };
    var handleOnNext = function () {
        onNext === null || onNext === void 0 ? void 0 : onNext();
        onChange === null || onChange === void 0 ? void 0 : onChange(currentPage + 1, currentPage);
    };
    var handleOnLast = function () {
        onLast === null || onLast === void 0 ? void 0 : onLast();
        onChange === null || onChange === void 0 ? void 0 : onChange(totalPages, currentPage);
    };
    var isFirstPage = currentPage <= 1;
    var isLastPage = currentPage >= totalPages;
    var firstPageButton = (0, jsx_runtime_1.jsx)(buttons_1.FirstPageButton, { "data-testid": "first", disabled: isFirstPage, onClick: handleOnFirst }, "first");
    var previousPageButton = (0, jsx_runtime_1.jsx)(buttons_1.PreviousPageButton, { "data-testid": "previous", disabled: isFirstPage, onClick: handleOnPrevious }, "previous");
    var nextPageButton = (0, jsx_runtime_1.jsx)(buttons_1.NextPageButton, { "data-testid": "next", disabled: isLastPage, onClick: handleOnNext }, "next");
    var lastPageButton = (0, jsx_runtime_1.jsx)(buttons_1.LastPageButton, { "data-testid": "last", disabled: isLastPage, onClick: handleOnLast }, "last");
    var pageNumbers = (0, usePageNumbers_1.usePageNumbers)(currentPage, totalPages, siblingCount);
    var pageItems = (0, react_1.useMemo)(function () {
        return pageNumbers.map(function (item, index) {
            if (item === usePageNumbers_1.ELLIPSIS) {
                var key = index === 1 ? "start--ellipsis" : "end--ellipsis";
                return (0, jsx_runtime_1.jsx)(Paginator_styles_1.Ellipsis, __assign({ className: "ellipsis ".concat(key), "data-testid": key }, { children: "..." }), key);
            }
            return ((0, jsx_runtime_1.jsx)(buttons_1.PageButton, __assign({ "data-testid": "page-".concat(item), selected: currentPage === item, onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(item, currentPage); } }, { children: item }), item));
        });
    }, [currentPage, pageNumbers, onChange]);
    var paginationItems = __spreadArray(__spreadArray([firstPageButton, previousPageButton], pageItems, true), [nextPageButton, lastPageButton], false);
    return ((0, jsx_runtime_1.jsx)(Paginator_styles_1.PageButtonList, __assign({ className: className, "data-testid": testId }, rest, { children: paginationItems })));
};
exports.Paginator = Paginator;
